export enum DraftOrderStatusType {
    Pending = 0,
    Processed = 1
}
